import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';


@inject('lineStore')
@observer
class Counter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeOutId: null
    };
  }

  counterRef = React.createRef();

  componentDidUpdate(nextProps) {
    if (Number(nextProps.count) !== Number(this.props.count)) {
      this.animate();
    }
  }

  animate() {
    if (this.state.timeOutId) {
      clearTimeout(this.state.timeOutId);
      this.setState({ timeOutId: null });
    } else if (this.counterRef.current) {
      this.counterRef.current.classList.add('animate');
    }

    this.state.timeOutId = setTimeout(() => {
      if (this.counterRef.current) {
        this.counterRef.current.classList.remove('animate');
      }
      clearTimeout(this.state.timeOutId);
      this.state.timeOutId = null;
    }, 2000);
  }

  render() {
    return (
      <div
        ref={this.counterRef}
        className="favourites-sport-item-count"
      >
        {this.props.count}
      </div>
    );
  }
}

export default Counter;




// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuCounter.jsx